import React from "react"
import { useInheritedTheme } from "../../hooks/use-theme"
import typographyStyles from "../../utils/typography-styles"
import SlateNode from "../slate-node"

const OrderedList = ({ attributes, children, data, serializingFind, node }) => {
  const { find: editingFind } = useInheritedTheme()
  const find = serializingFind || editingFind

  const style = {
    ...typographyStyles("paragraph", find),
    textAlign: data.alignment,
    listStylePosition: "inside"
  }

  return (
    <SlateNode
      as="ol"
      node={node}
      className="unordered_list"
      {...attributes}
      style={style}
    >
      {children}
    </SlateNode>
  )
}

export default {
  component: OrderedList
}
